import React from "react";

const TermsAndConditions = () => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8">
          <h1 className="mb-4 text-center">Terms and Conditions</h1>
          <p className="text-dark text-center mb-5">
            <strong>Effective Date:</strong> June 2025
            <br />
            <strong>Company Name:</strong> WebPebble Ltd<br />
            <strong>Trading As:</strong> SEOptimist<br />
            <strong>Registered Address:</strong> 26 Hertingfordbury Road, Hertford, SG14 1JX
          </p>

          <h2 className="mb-3">1. Introduction</h2>
          <p>
            These Terms and Conditions govern your use of the SEOptimist website and the services provided by WebPebble Ltd (“we”, “us”, or “our”). By accessing or using our services, you agree to comply with these terms.
          </p>

          <h2 className="mb-3">2. Services</h2>
          <p>
            We provide search engine optimisation (SEO) and related website design services as detailed on our website or in a written agreement.
          </p>

          <h2 className="mb-3">3. Contract Formation</h2>
          <p>
            A contract for services is formed when we accept your order or enquiry, either by written confirmation or by beginning work on your project.
          </p>

          <h2 className="mb-3">4. Payment</h2>
          <p>
            Unless otherwise agreed, payment is required in advance or as specified in your service agreement. We reserve the right to suspend or terminate services for non-payment.
          </p>

          <h2 className="mb-3">5. Cancellation and Refunds</h2>
          <p>
            You may cancel your order within 14 days of contract formation, unless work has already commenced. Refunds, if applicable, will be processed as per our refund policy.
          </p>

          <h2 className="mb-3">6. Intellectual Property</h2>
          <p>
            All intellectual property rights in materials provided by us remain our property until full payment is received. Upon payment, you are granted a non-exclusive, non-transferable licence to use the materials for your business.
          </p>

          <h2 className="mb-3">7. Limitation of Liability</h2>
          <p>
            We shall not be liable for any indirect, incidental, or consequential damages arising from the use of our services. Our liability is limited to the amount paid by you for the services.
          </p>

          <h2 className="mb-3">8. Data Protection</h2>
          <p>
            We process your personal data in accordance with our Privacy Policy and applicable UK data protection laws.
          </p>

          <h2 className="mb-3">9. Changes to Terms</h2>
          <p>
            We may update these terms from time to time. Continued use of our services after changes are posted constitutes acceptance of the revised terms.
          </p>

          <h2 className="mb-3">10. Governing Law</h2>
          <p>
            These terms are governed by the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.
          </p>

          <h2 className="mb-3">11. Contact Us</h2>
          <address>
            <strong>WebPebble Ltd</strong><br />
            26 Hertingfordbury Road<br />
            Hertford<br />
            SG14 1JX<br />
            Email: james [@] moltoseo.co.uk<br />
            Phone: <a href="tel:+447441397020" className="text-primary">+44 (0)744 139 7020</a>
          </address>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
